
import { useState } from 'react';
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation)} ${className}`}>
      {children}
    </div>
  );
}

export default function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Puedo cambiar de plan en cualquier momento?',
      answer: 'Sí, puedes actualizar o cambiar tu plan en cualquier momento. Si actualizas, solo pagarás la diferencia proporcional. Si bajas de plan, el cambio se aplicará al siguiente ciclo de facturación.',
    },
    {
      question: '¿Hay algún costo de implementación?',
      answer: 'No. La implementación está incluida en todos los planes. Nuestro equipo configura tu cuenta, migra tus datos y capacita a tu equipo sin costo adicional.',
    },
    {
      question: '¿Qué métodos de pago aceptan?',
      answer: 'Aceptamos tarjetas de crédito y débito (Visa, Mastercard, American Express), transferencias bancarias y PayPal. Para planes Enterprise, también ofrecemos facturación personalizada.',
    },
    {
      question: '¿Ofrecen descuentos para múltiples consultorios?',
      answer: 'Sí. Si gestionas más de 3 consultorios, contáctanos para obtener un precio especial adaptado a tus necesidades. Los descuentos por volumen pueden llegar hasta un 30%.',
    },
    {
      question: '¿Qué pasa con mis datos si cancelo?',
      answer: 'Tus datos te pertenecen. Si cancelas, tienes 30 días para exportar toda tu información. Después de ese período, los datos se eliminan de forma segura de nuestros servidores.',
    },
    {
      question: '¿El Módulo de Óptica tiene costo adicional?',
      answer: 'No. El Módulo de Óptica está incluido sin costo adicional en los planes Profesional y Enterprise. Incluye gestión de inventario, catálogo de productos, promociones y más.',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold text-emerald-600 uppercase tracking-widest mb-3">FAQ</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Preguntas sobre <span className="font-display italic text-emerald-600">precios</span>
            </h2>
          </div>
        </AnimatedSection>

        <AnimatedSection animation="slide-up">
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-100 rounded-xl overflow-hidden hover:border-emerald-200 transition-colors bg-white"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer group"
                >
                  <span className="text-sm font-semibold text-gray-900 pr-4">{faq.question}</span>
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                    openIndex === index ? 'bg-emerald-500 rotate-180' : 'bg-gray-100 group-hover:bg-emerald-50'
                  }`}>
                    <i className={`ri-arrow-down-s-line text-base ${openIndex === index ? 'text-white' : 'text-gray-500'}`}></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
